const HouseholdRelationLabels = Object.freeze({
  PARENT: 'parent',
  CHILD: 'child',
  SPOUSE: 'spouse',
  SIBLING: 'sibling',
  EXTENDED_FAMILY: 'extended_family',
});

export default HouseholdRelationLabels;
